import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { IonicModule } from "@ionic/angular";

import { AutofillDirective } from "../lib/autofill.directive";
import { AccountModalComponent } from "./account-modal/account-modal.component";
import { BaseToolbarComponent } from "./base-toolbar/base-toolbar.component";
import { LoginModalComponent } from "./login-modal/login-modal.component";

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, ReactiveFormsModule, RouterModule],
  declarations: [LoginModalComponent, AccountModalComponent, BaseToolbarComponent, AutofillDirective],
  exports: [LoginModalComponent, AccountModalComponent, BaseToolbarComponent, AutofillDirective],
})
export class TemplatesModule {}
